<header class="header">
  <div class="header__left">
    <img src="assets/images/logo-horus.svg" alt="Logo" class="header__logo" />
    <app-search-summary-card></app-search-summary-card>
  </div>
  <div class="header__right">
    <app-module-tabs></app-module-tabs>
    <app-toggle-button
      [paths]="{
        stock: getTenantPath('/stock-physical'),
        store: getTenantPath('/search-stores')
      }"
    >
      <ng-container
        *appToggleOption="'stock'; label: 'Consulta de stock'">
        <app-stock-grid-icon />
      </ng-container>

      <ng-container
        *appToggleOption="'store'; label: 'Búsqueda de tiendas'">
        <app-store-icon />
      </ng-container>
    </app-toggle-button>
    <button mat-mini-fab>
      <mat-icon fontSet="material-icons-outlined">notifications</mat-icon>
    </button>
    <app-user-dropdown></app-user-dropdown>
  </div>
</header>
